import fetch from 'isomorphic-unfetch'
import Layout from '../../components/Layout'
import Youtube from '../../components/Youtube'
import Header from '../../components/Header'
import Feature2Row from '../../components/Feature2Row'
import Feature4Column from '../../components/Feature4Column'
import FooterForm from '../../components/FooterForm'
import FooterForm2 from '../../components/FooterForm2'
import Footer from '../../components/Footer'
import bg from '../../static/kid/bg.jpg';
import { baseAPI } from '../../constant/global_constant'

const type = 'kidsnew'
const nav = [
    /*
    { id: 1, title: '特色', href: '#feature' },
    { id: 2, title: '聯絡我們', href: '#contact' },
    */
]

const feature_image = [
    { id: 1, src: require('../../static/kidsnew/img9.jpg') },
    { id: 1, src: require('../../static/kidsnew/img10.jpg') },
]

const features_group_a = [
    { id: 1, title: '一對一高強度專注力教學', description: '提供一對一有進度的主課程及客製加強班，可針對孩子學習需求做選修補強，如：兒童檢定課程、發音、文法。', src: require('../../static/kidsnew/icon1.png') },
    { id: 2, title: '同步英美小學優質教材', description: '使用全球暢銷且同步英美小學的ESL兒童英語教材，搭配新課綱及檢定教材，紮實步驟穩定學習。完整學習規劃。', src: require('../../static/kidsnew/icon2.png') },
]

const features_group_b = [
    { id: 3, title: '嚴選專業優良證照師資', description: '堅持純正標準口音的師資，以「全英語」環境進行教學，讓孩子在語感模仿能力最強的階段，學習最道地的英語發音。', src: require('../../static/kidsnew/icon3.png') },
    { id: 4, title: '客製需求學校輔導課程', description: '兼顧學校課業成績，可針對孩子的學校課業以及考試成績，自備教材，客製加強輔導，達到客製化空中家教。', src: require('../../static/kidsnew/icon4.png') },
]

const sub_features = [
    { id: 1, title: '親子安心共學貼心透明教室', line1: '親子安心共學', line2: '貼心透明教室', src: require('../../static/kidsnew/icon5.png') },
    { id: 2, title: '獎勵學習金幣激發學習動力', line1: '獎勵學習金幣', line2: '激發學習動力', src: require('../../static/kidsnew/icon6.png') },
    { id: 3, title: '專屬學習導師完全掌握追蹤', line1: '專屬學習導師', line2: '完全掌握追蹤', src: require('../../static/kidsnew/icon7.png') },
    { id: 4, title: '免去接送時間節省通勤成本', line1: '免去接送時間', line2: '節省通勤成本', src: require('../../static/kidsnew/icon8.png') },
]

const video = 'https://www.youtube.com/channel/UCZtOD5dWdZGFx_GwbQg5NGg';

const Index = (props) => (
    <Layout nav={nav} type={type} title={props.data && props.data.meta_title} data={props.data}>
        <Header
            bg={props.data && props.data.background || bg}
            mobile_bg={props.data && props.data.mobile_background || bg}
            data={props.data} style={{
            backgroundColor: 'black',
        }
        }/>
        <Youtube />
        <Feature2Row feature_image={feature_image} features_group_a={features_group_a} features_group_b={features_group_b} title="Etalking Kids 有我們的堅持，只給寶貝孩子最好的" />
        <Feature4Column sub_features={sub_features} title="讓孩子有效且快樂的學習，讓家長放心" />
        <FooterForm2 id={props.id} type={type} data={props.data} />
        <Footer type={type} />
        <style jsx>{`
      h1, a {
        font-family: "Arial";
      }

      ul {
        padding: 0;
      }

      li {
        list-style: none;
        margin: 5px 0;
      }

      a {
        text-decoration: none;
        color: blue;
      }

      a:hover {
        opacity: 0.6;
      }
    `}</style>
    </Layout>
)

Index.getInitialProps = async (context) => {
    const { id } = context.query
    if (id) {
        var options = {cache: "no-cache"};

        const res = await fetch(`${baseAPI}marketing/${id}`, options)
        const { data }  = await res.json()
        data.background = (data.background && data.background.startsWith('http')) ?
            data.background :
            `http://${data.background}`
        data.mobile_background = (data.mobile_background && data.mobile_background.startsWith('http')) ?
            data.mobile_background :
            `http://${data.mobile_background}`

        let ary = []
        const regex1 = /<script\b[^>]*>([\s\S]*?)<\/script>/gm
        const regex2 = /<script.*?src="(.*?)"/
        // const regex2 = /<script[^>]*>((.|[\n\r])*)<\/script>/im
        const matches = data.script_header.match(regex1)
        matches && matches.forEach((element) => {
            if (new RegExp('<script(.)*><\/script>').test(element)) {
                data.headSrc = element.match(regex2) && element.match(regex2).length === 2 && element.match(regex2)[1]
            } else {
                ary.push(element.replace('<script', '').replace('</script>', '').replace('>', ''))
            }
        });
        data.injectJSinHead = ary
        data.script_body = data.script_body.replace('<script>', '').replace('</script>', '')
        data.script_google = data.script_google.replace('<script>', '').replace('</script>', '')
        return { data: data || {}, id }
    } else {
        return  { data: {} }
    }
}

export default Index
